// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__VIkTz","unreadBadge":"styles_unreadBadge__2FcIO","modalContent":"styles_modalContent__1yjg_","modal":"styles_modal__1jmp2"};